import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Alert, Button, Label, Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import { gql } from 'apollo-boost';
import { Mutation } from 'react-apollo';
import { Formik } from 'formik';
import moment from 'moment';
import FormikInputField from '~/components/formikInputField/formikInputField';
import SubmissionButton from '~/components/submissionButton/submissionButton';
import { lotTransferDateChangeValidationSchema } from '~/validation/lot';

export const changeLotTransferDateMutation = gql`
  mutation changeLotTransferDate(
    $lotTransferId: Int!
    $transferDate: String!
    $changeFollowingTransferDates: Boolean!
  ) {
    changeLotTransferDate(
      lotTransferId: $lotTransferId
      transferDate: $transferDate
      changeFollowingTransferDates: $changeFollowingTransferDates
    ) {
      id
    }
  }
`;

const ChangeLotTransferForm = ({ values, handleSubmit, onCancelClick, transfer, errors, isSubmitting }) => {
  return (
    <form onSubmit={handleSubmit}>
      <ModalBody>
        {errors.unknown && <Alert color="danger">{errors.unknown}</Alert>}
        <div className="mb3">
          <Label>When dates do you want to change this transfer to?</Label>
          <FormikInputField type="date" name="transferDate" invalid={!!errors.transferDate} />
          {errors.transferDate && <p className="error">{errors.transferDate}</p>}
          <p className="f6 sh mt2">(Current transfer date is {moment(transfer.transferDate).format('dddd Do MMMM')}}</p>
        </div>
        <div className="relative pl4 flex">
          <FormikInputField
            checked={values.changeFollowingTransferDates}
            type="checkbox"
            name="changeFollowingTransferDates"
          />
          <Label>Also adjust any following transfers respectively?</Label>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onCancelClick}>
          Cancel
        </Button>{' '}
        <SubmissionButton type="submit" color="primary" isSubmitting={isSubmitting}>
          Clone
        </SubmissionButton>
      </ModalFooter>
    </form>
  );
};

export class CloneLotsModal extends Component {
  state = {
    error: null
  };
  render() {
    const { transfer, isOpen, onToggle, onSuccess, brewery } = this.props;
    return (
      <Modal isOpen={isOpen} toggle={onToggle}>
        <ModalHeader toggle={onToggle}>Change lot transfer date</ModalHeader>
        <Mutation mutation={changeLotTransferDateMutation}>
          {changeLotTransferDate => (
            <Formik
              initialValues={{
                transferDate: transfer.transferDate,
                changeFollowingTransferDates: false
              }}
              validationSchema={lotTransferDateChangeValidationSchema}
              validateOnChange={false}
              validateOnBlur={false}
              onSubmit={async (values, { setErrors, setSubmitting }) => {
                try {
                  await changeLotTransferDate({
                    variables: {
                      lotTransferId: transfer.id,
                      transferDate: values.transferDate,
                      changeFollowingTransferDates: values.changeFollowingTransferDates
                    },
                    awaitRefetchQueries: true,
                    refetchQueries: ['lot']
                  });
                  onSuccess();
                } catch (err) {
                  console.log(err);
                  setErrors({
                    unknown: 'An unknown error occured'
                  });
                  setSubmitting(false);
                }
              }}
              render={props => (
                <ChangeLotTransferForm
                  {...props}
                  brewery={brewery}
                  transfer={transfer}
                  onCancelClick={onToggle}
                  onSuccess={onSuccess}
                />
              )}
            />
          )}
        </Mutation>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}
export default connect(mapStateToProps)(CloneLotsModal);



// WEBPACK FOOTER //
// ./src/containers/changeLotTransferDateModal/changeLotTransferDateModal.jsx